// Google Ads conversion tracking (same tag as prosprotection.store)
// Google Ads ID: AW-18001331429
// Conversion label: rfD-CNj07YQcEOWJ2odD (Submit lead form)

export const GA_CONVERSION_ID = "AW-18001331429";
export const GA_CONVERSION_SEND_TO = "AW-18001331429/rfD-CNj07YQcEOWJ2odD";

/**
 * Fire a Google Ads conversion event (Submit lead form).
 * Mirrors the exact snippet used on prosprotection.store.
 * @param {Object} opts optional overrides { value, currency, transaction_id }
 * @returns {boolean} whether the event was pushed
 */
export function trackLeadConversion(opts = {}) {
  const payload = {
    send_to: GA_CONVERSION_SEND_TO,
    value: opts.value ?? 1.0,
    currency: opts.currency ?? "INR",
  };
  if (opts.transaction_id) payload.transaction_id = opts.transaction_id;

  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", payload);
      return true;
    }
    // Fallback: push directly into dataLayer if gtag() isn't defined yet
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(["event", "conversion", payload]);
    }
  } catch (e) {
    // no-op - tracking should never break UX
  }
  return false;
}

/**
 * Attach the conversion event to a phone-call click (Call CTA).
 * Use like: onClick={trackPhoneCallClick}
 */
export function trackPhoneCallClick() {
  trackLeadConversion();
}
